import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';

export interface EmspBoLocationCountryFilterStateControllerProps {
  value: string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoLocationCountryFilterStateController = ({
  value,
  onRemove,
}: EmspBoLocationCountryFilterStateControllerProps): React.JSX.Element => (
  <FilteredItem icon="globe-02" label={value} onRemove={onRemove} />
);
